import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input } from "@gpstrackit/react-controls";
import CustomSelect from 'Components/Select';
import { NotificationManager } from "Components/Notifications";
import { Alert } from '@mui/material';
import { getDevices } from './redux/saga';

//Actions
import { associateToGpsRequest, clearRedux } from 'Redux/actions';

//Styles
import "./index.scss";

const AssociateToGPS = (props) => {
    const { device, getDevice } = props;
    const formRef = useRef(null);
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const [gpsDevice, setGpsDevice] = useState(null);
    const [linkedByUnit, setLinkedByUnit] = useState(false);

    const { loading, openModal, result } = useSelector(state => state.associateToGpsRedux);

    const closeModal = () => {
        setGpsDevice(null);
        setLinkedByUnit(false);
        dispatch(clearRedux("ASSOCIATE_TO_GPS"))
    }

    const pairingDevices = () => {
        let payload = {
            "unitIdCamera": device?.id,
            "unitIdGps": gpsDevice?.id
        }
        dispatch(associateToGpsRequest(payload))
    }

    const deviceHandler = (newDevice) => {
        if (newDevice?.linkedByUnit?.id) {
            setLinkedByUnit(true);
        } else {
            setLinkedByUnit(false);
        }
        let validateVidfleet = newDevice?.deviceModel?.manufacturer?.name.toUpperCase() === "VIDFLEET";
        let validateSmartWitness = newDevice?.deviceModel?.manufacturer?.name.toUpperCase() === "SMARTWITNESS";
        if (validateVidfleet || validateSmartWitness) {
            setGpsDevice(null);
            NotificationManager.error(
                messages['associate_to_gps_error_message'],
                messages['associate_to_gps_title'],
                3000
            );
        } else setGpsDevice(newDevice);
    }

    const getDevicesForSelect = (input, callback) => {
        setLinkedByUnit(false);
        if (!input) {
            callback([])
            return
        }
        let companyId = device?.companyId
        getDevices(input, companyId).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    useEffect(() => {
        if (result && result?.errorMessage === "") {
            NotificationManager.success(
                messages['associate_to_gps_success_message'],
                messages['associate_to_gps_title'],
                3000
            );
            closeModal();
            getDevice && getDevice();
        } else if (result && result?.errorMessage !== "") {
            NotificationManager.error(
                result?.errorMessage,
                messages['associate_to_gps_title'],
                3000
            );
            dispatch(clearRedux("ASSOCIATE_TO_GPS", { result: null }))
        }
    }, [result]);

    return (
        <Modal
            open={openModal}
            title={messages['associate_to_gps_title']}
            handleClose={() => closeModal()}
            position="right"
            size="small"
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', height: '80vh' }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => { }}
                    >
                        <div className="search-gps-device">
                            <Input
                                id="vidfleet-device-esn"
                                label={messages['associate_to_gps_vidfleet_device_esn']}
                                value={device?.esn || ''}
                                disabled
                                placeholder={messages['associate_to_gps_vidfleet_device_esn']}
                                onChange={(value) => { }}
                            />
                        </div>
                        <div style={{ marginTop: 10 }}>
                            <CustomSelect
                                async
                                value={gpsDevice}
                                onChange={(items) => deviceHandler(items)}
                                label={messages['associate_to_gps_search_gps_device']}
                                loadOptions={getDevicesForSelect}
                                loading={false}
                                required
                                getOptionLabel={e => {
                                    let label = `${e.label} ${e?.deviceModel?.manufacturer?.name ? `(${e.deviceModel.manufacturer.name})` : ''}`
                                    return label
                                }}
                                getOptionValue={e => e.id}
                                placeholder={messages['associate_to_gps_search_by']}
                            />
                            {
                                linkedByUnit &&
                                <Alert
                                    style={{ marginBottom: 5, marginTop: 5 }}
                                    severity="info"
                                >
                                    {messages['associate_to_gps_alert_message']}
                                </Alert>
                            }
                        </div>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['close']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => pairingDevices()}
                >
                    {messages['associate_to_gps_pair']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default AssociateToGPS;